// ============================================
// API Configuration
// Update CONTACT_API_URL with your backend endpoint
// ============================================

const API_CONFIG = {
  // Replace this with your actual backend API URL
  CONTACT_API_URL: 'https://your-backend-api.com/api/contacts',
  CALLBACK_API_URL: 'https://your-backend-api.com/api/callbacks',
};

/**
 * Submit contact form data to backend API
 */
export async function submitContactForm(formData) {
  try {
    const response = await fetch(API_CONFIG.CONTACT_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...formData,
        submittedAt: new Date().toISOString(),
        source: 'bridgelpo-website',
        formType: 'contact',
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Contact form submission error:', error);
    throw error;
  }
}

/**
 * Submit callback request to backend API
 */
export async function submitCallbackRequest(formData) {
  try {
    const response = await fetch(API_CONFIG.CALLBACK_API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...formData,
        submittedAt: new Date().toISOString(),
        source: 'bridgelpo-website',
        formType: 'callback',
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Callback form submission error:', error);
    throw error;
  }
}

export default API_CONFIG;
